/* import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ReportDefinitionLine} from '../domain/reportdefinitionline';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { Configuration } from '../domain/configuration';
import { Totaling } from '../domain/totaling';

@Injectable({
  providedIn: 'root'
})
export class LineService {


    uri = '/api/line';

    constructor(private http: HttpClient, private messageService: MessageService) {}

    count(reportId : number) : Observable<number> {
        let countUri = `${this.apiUrl}${this.uriPath}/count-for/${reportId}`;
        return this.http.get<number>(countUri);
    }

    get(reportId : number,
        from: number, count: number,
        sortField: string,
        asc : boolean,
        filter : any //TODO napraviti klasu filter...
        ) : Promise<ReportDefinitionLine[]>
    {
        let getUri = `${this.apiUrl}${this.uriPath}/all-for/${reportId}/${count}-from-${from}/${asc}/by/${sortField}/`;
        let promise = this.http.get<ReportDefinitionLine[]>(getUri)
                          .toPromise();
        //promise.then(data => console.log('Report lines: ' + JSON.stringify(data)));
        return promise;
    }

    getById(id: number) : Promise<ReportDefinitionLine> {
        let promise = this.http.get<ReportDefinitionLine>(`${this.apiUrl}${this.uriPath}/${id}`)
                          .toPromise();
        //promise.then(data => console.log('Line : ' + JSON.stringify(data)));
        return promise;
    }

    post(obj: ReportDefinitionLine) {

        let promise =  this.http
                           .post<ReportDefinitionLine>(`${this.apiUrl}${this.uriPath}`, obj )
                           .toPromise();
        promise.then( oa => {
              obj.Id = oa.Id;
                this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Stavka izvještaja dodana' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Saving failed', detail: error.status + ':' + error.error })
        });
        return promise;
    }

    put(obj: ReportDefinitionLine) {
        let promise =  this.http
                           .put<ReportDefinitionLine>(`${this.apiUrl}${this.uriPath}/${obj.Id}`, obj )
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Stavka izvještaja ažurirana' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Saving failed', detail: error.status + ':' + error.error })
        });
        return promise;
    }

    updateOnlyTotaling(id: any, obj: Totaling[]) {
        let promise =  this.http
                           .put<Totaling[]>(`${this.apiUrl}${this.uriPath}/update-only-totaling-${id}`, obj )
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Totaling updated!' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Sacing failed', detail: error.status + ':' + error.error })
        });
        return promise;
    }

    swapLineNoFor(id1, id2) {
        let promise =  this.http
                           .put(`${this.apiUrl}${this.uriPath}/swap-lineno-for-${id1}-${id2}`, {})
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Pomak uspješan', detail: 'Zamjena uspješna' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Zamjena neuspješna', detail: error.status + ':' + error.error })
        });
        return promise;
    }

    delete(id: string) {
        let promise =  this.http
                           .delete(`${this.apiUrl}${this.uriPath}/${id}`)
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Brisanje uspješno', detail: 'Stavka izvještaja obrisana' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Saving failed', detail: error.status + ':' + error.error })
        });
        return promise;
    }
}
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DynamicBackendConfigService } from './dynamic-backend-config.service';
import { ReportDefinitionLine } from '../domain/reportdefinitionline';
import { Totaling } from '../domain/totaling';
import { AppConfigService } from './app-config.service';
import { ReportLines } from '../domain/reportlines';
import { IdName } from '../domain/idname';
import { Utils } from 'src/app/utilities/utils';

@Injectable({
  providedIn: 'root'
})
export class LineService {
    private uriPath = '/api/line';
    uri = '';
    apiUrl="";
  
    constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private dynamicBackend: DynamicBackendConfigService,
    private appConfigService: AppConfigService
  ) {
    this.apiUrl = this.appConfigService.apiUrl;
    /*this.dynamicBackend.getApiUrl().subscribe(apiUrl => {
      this.uri =  this.dynamicBackend.extractSecondURL(apiUrl ? `${apiUrl}${this.uriPath}` : this.uriPath);
    });*/
  }

  count(reportId : number) : Observable<number> {
    let countUri = `${this.apiUrl}${this.uriPath}/count-for/${reportId}`;
    return this.http.get<number>(countUri);
}

get(reportId : number,
    from: number, count: number,
    sortField: string,
    asc : boolean,
    filter : any //TODO napraviti klasu filter...
    ) : Promise<ReportDefinitionLine[]>
{
    let getUri = `${this.apiUrl}${this.uriPath}/all-for/${reportId}/${count}-from-${from}/${asc}/by/${sortField}/`;
    let promise = this.http.get<ReportDefinitionLine[]>(getUri)
                      .toPromise();
    //promise.then(data => console.log('Report lines: ' + JSON.stringify(data)));
    return promise;
}

getForTreeGrid(reportId : number,
    from: number, count: number,
    sortField: string,
    asc : boolean,
    filter : any //TODO napraviti klasu filter...
    ) : Promise<ReportDefinitionLine[]>
{
    let getUri = `${this.apiUrl}${this.uriPath}/all-for-tree-grid/${reportId}/${count}-from-${from}/${asc}/by/${sortField}/`;
    let promise = this.http.get<ReportDefinitionLine[]>(getUri)
                      .toPromise();
    //promise.then(data => console.log('Report lines: ' + JSON.stringify(data)));
    return promise;
}

getAllForReport(reportId : number, lineId: number
    ) : Promise<IdName[]>
{
    let getUri = `${this.apiUrl}${this.uriPath}/all-for-report/${reportId}/${lineId}`;
    let promise = this.http.get<IdName[]>(getUri)
                      .toPromise();
    //promise.then(data => console.log('Report lines: ' + JSON.stringify(data)));
    return promise;
}

getAllLines() : Promise<ReportLines[]>
{
    let getUri = `${this.apiUrl}${this.uriPath}/all-for`;
    let promise = this.http.get<ReportLines[]>(getUri)
                      .toPromise();
    //promise.then(data => console.log('Report lines: ' + JSON.stringify(data)));
    return promise;
}

getById(id: number) : Promise<ReportDefinitionLine> {
    let promise = this.http.get<ReportDefinitionLine>(`${this.apiUrl}${this.uriPath}/${id}`)
                      .toPromise();
    //promise.then(data => console.log('Line : ' + JSON.stringify(data)));
    return promise;
}

getByReportIdEndRowNo(reportId : number, rowNo: string) : Promise<ReportDefinitionLine> {
    let promise = this.http.get<ReportDefinitionLine>(`${this.apiUrl}${this.uriPath}/one-for-line/${reportId}/${rowNo}`)
                      .toPromise();
    //promise.then(data => console.log('Line : ' + JSON.stringify(data)));
    return promise;
}
post(obj: ReportDefinitionLine) {

    let promise =  this.http
                       .post<ReportDefinitionLine>(`${this.apiUrl}${this.uriPath}`, obj )
                       .toPromise();
    promise.then( oa => {
          obj.Id = oa.Id;
            this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Report item added' })
    })
    .catch(error => {
        this.messageService.add({ severity: 'error', summary: 'Saving failed', detail: Utils.extractSQLError(error.error) })
    });
    return promise;
}

copy(id:number,reportId:number,companyId:number) {

    let promise = this.http.get(`${this.apiUrl}${this.uriPath}/copy/${id}/${reportId}/${companyId}`)
    .toPromise();
    promise.then( oa => {
          this.messageService.add({ severity: 'success', summary: 'Copy successful', detail: 'Report line copied' })
  })
  .catch(error => {
      this.messageService.add({ severity: 'error', summary: 'Copy failed', detail: Utils.extractSQLError(error.error) })
  });
  return promise;
}

put(obj: ReportDefinitionLine) {
    let promise =  this.http
                       .put<ReportDefinitionLine>(`${this.apiUrl}${this.uriPath}/${obj.Id}`, obj )
                       .toPromise();
    promise.then( oa => {
            this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Report item updated' })
    })
    .catch(error => {
        this.messageService.add({ severity: 'error', summary: 'Saving failed', detail: Utils.extractSQLError(error.error) })
    });
    return promise;
}

updateOnlyTotaling(id: any, obj: Totaling[]) {
    let promise =  this.http
                       .put<Totaling[]>(`${this.apiUrl}${this.uriPath}/update-only-totaling-${id}`, obj )
                       .toPromise();
    promise.then( oa => {
            this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Totaling updated!' })
    })
    .catch(error => {
        this.messageService.add({ severity: 'error', summary: 'Sacing failed', detail: Utils.extractSQLError(error.error) })
    });
    return promise;
}

swapLineNoFor(id1, id2) {
    let promise =  this.http
                       .put(`${this.apiUrl}${this.uriPath}/swap-lineno-for-${id1}-${id2}`, {})
                       .toPromise();
    promise.then( oa => {
            this.messageService.add({ severity: 'success', summary: 'Swap successful', detail: 'Swap successful!' })
    })
    .catch(error => {
        this.messageService.add({ severity: 'error', summary: 'Swap not successful', detail: Utils.extractSQLError(error.error) })
    });
    return promise;
}

reorderLineOnWithParent(reorderedList: { id: number, newLineOn: string, parentId: number | null }[]) {
  let promise = this.http
    .put(`${this.apiUrl}${this.uriPath}/reorder-rownos`, reorderedList)
    .toPromise();

  promise.then(() => {
    this.messageService.add({ 
      severity: 'success',
      summary: 'Reorder successful',
      detail: 'Rows reordered successfully.'
    });
  }).catch(error => {
    this.messageService.add({
      severity: 'error',
      summary: 'Reorder failed',
      detail: Utils.extractSQLError(error.error)
    });
  });

  return promise;
}

reorderRowNos(items: any[]): Promise<any> {
  return this.http
    .put(`${this.apiUrl}${this.uriPath}/reorder-rownos`, items)
    .toPromise();
}

delete(id: string) {
    let promise =  this.http
                       .delete(`${this.apiUrl}${this.uriPath}/${id}`)
                       .toPromise();
    promise.then( oa => {
            this.messageService.add({ severity: 'success', summary: 'Delete successful', detail: 'Report item deleted!' })
    })
    .catch(error => {
        this.messageService.add({
            severity: 'error',
            summary: 'Deleting failed',
            detail: Utils.extractSQLError(error?.error)
        })
    });
    return promise;
}
}
